export const BRIDGE_TRANSFER_LOADING_TEXT = 'Gathering Plans...'

/**
 * LaunchDarkly flag key for Document Center (object JSON, legacy boolean, or legacy string[] allowlist).
 * See `isProductEnrollmeDocumentCenterEnabled` in `useFeatureFlags.ts`.
 */
export const LD_FLAG_PRODUCT_ENROLLME_DOCUMENT_CENTER = 'product.enrollme.document-center' as const
